import { Button } from "@material-ui/core";
import { useField } from "react-final-form";
import React from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";

interface IShowRouteButton {
  route: any;
  index: number;
  handleOpenRoutePanel: (x: boolean, y: number) => void;
  handleExistingMarkers: any;
}

const ShowRouteButton = ({
  route,
  index,
  handleOpenRoutePanel,
  handleExistingMarkers,
}: IShowRouteButton) => {
  const routeIdField = useField("route.id");
  const routeNameField = useField("route.name");
  const routeBusBayNumberField = useField("route.busBayNumber");
  const routeStartTimeField = useField("route.startTime");
  const routeEndTimeField = useField("route.endTime");
  const routeDriverIdField = useField("route.driverId");
  const routeBusAssistantIdField = useField("route.busAssistantId");
  const routeVehicleIdField = useField("route.vehicleId");

  // for subcontractor payment
  const routeSubcontractorIdField = useField(
    "route.assignedSubcontractor.subcontractorId"
  );
  const routeVehicleSizeField = useField(
    "route.assignedSubcontractor.vehicleSize"
  );
  const routeStartDateField = useField("route.assignedSubcontractor.startDate");
  const routeEndDateField = useField("route.assignedSubcontractor.endDate");

  const routeBackupDriversField = useField("route.backupDriverIds");
  const routeBackupVehiclesField = useField("route.backupVehicleIds");
  const routeBackupBusAssistantsField = useField("route.backupBusAssistantIds");
  const routeLocationsField = useField("route.routeLocations");

  const openExistingRoute = async (data: any) => {
    routeIdField.input.onChange(data.id ?? 0);
    routeNameField.input.onChange(data.name);
    routeBusBayNumberField.input.onChange(data.busBayNumber);
    routeStartTimeField.input.onChange(data.startTime);
    routeEndTimeField.input.onChange(data.endTime);
    routeDriverIdField.input.onChange(data.driverId);
    routeBusAssistantIdField.input.onChange(data.busAssistantId);
    routeVehicleIdField.input.onChange(data.vehicleId);

    // for subcontractor payment
    routeSubcontractorIdField.input.onChange(
      data.assignedSubcontractor?.subcontractorId
    );
    routeVehicleSizeField.input.onChange(
      data.assignedSubcontractor?.vehicleSize
    );
    routeStartDateField.input.onChange(data.assignedSubcontractor?.startDate);
    routeEndDateField.input.onChange(data.assignedSubcontractor?.endDate);

    routeBackupDriversField.input.onChange(
      data.backupDrivers
        ? data.backupDrivers.map((backupDriver: IDriver) => backupDriver.id)
        : data.backupDriverIds
    );
    routeBackupVehiclesField.input.onChange(
      data.backupVehicles
        ? data.backupVehicles.map((backupVehicle: IVehicle) => backupVehicle.id)
        : data.backupVehicleIds
    );
    routeBackupBusAssistantsField.input.onChange(
      data.backupBusAssistants
        ? data.backupBusAssistants.map(
            (backupBusAssistant: IDriver) => backupBusAssistant.id
          )
        : data.backupBusAssistantIds
    );

    data.routeLocations.map(
      (routeLocation: any, indexRouteLocation: number) => {
        // convert ASCII Code into Alphabet
        // 65 === A
        const locationCode = String.fromCharCode(65 + indexRouteLocation);

        routeLocation.students
          .sort((a: any, b: any) => a.id - b.id)
          .map((student: IStudent, indexStudent: number) => {
            student.locationCode = `${locationCode}${indexStudent + 1}`;
          });
      }
    );

    routeLocationsField.input.onChange(data.routeLocations);
  };

  return (
    <Button
      onClick={() =>
        openExistingRoute(route).then(() => {
          handleExistingMarkers(route.routeLocations);
          handleOpenRoutePanel(true, index);
        })
      }
    >
      <VisibilityIcon />
    </Button>
  );
};

export default ShowRouteButton;
